<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="CHAPTER1" id="uzpynFK6Vo38YHWpUbZEfK6">ACKNOWLEDGMENTS</p>
<p class="FIRSTPARAGRAPH">I owe a very special round of gratitude to:</p>
<p class="Normal">Eileen O’Callaghan, my loving and supportive wife, who shares life in so many wonderful ways, Kelliann Green, for her ongoing encouragement and support, Stephen Ohayon, Ph.D., a true gentleman, who inspired me tirelessly from the conception of my writing career, Noreen Nolan Patrone, who kept me on track, Matt Bialer, a trusted friend, Dick Marek, a man from whom I’ve learned much, and my dear friends Christine Charles, Marla Feder, Kathy Lord Nicolosi and Priscilla Winkler who listened, considered and advised.</p>
<p class="Normal">Phil Adaszewski, NYPD, Margaret Timlin Johnsen, NYPD, (retired), and Doctor Susan Sachs, DACM, FASEMIP, L.Ac for their expert technical advice and skillful guidance.</p>
<p class="Normal">And to my loving granddaughter, Kristin, who calls me PaPa and watches me melt.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgments.vue?4bac92f5